<template>
  <q-menu
    context-menu
    bordered
    side="right"
    overlay
  >
    <q-list>
      <template v-if="reportTableColumn.groupable">
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('remove-group-by', reportTableColumn.field)"
        >
          <q-item-section avatar>
            <q-icon name="block" />
          </q-item-section>
          <q-item-section>
            Ungroup
            <span class="text-bold">
              {{ reportTableColumn.label }}
            </span>
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('edit-groupings')"
        >
          <q-item-section avatar>
            <q-icon name="edit" />
          </q-item-section>
          <q-item-section>
            Edit Groupings
          </q-item-section>
        </q-item>
        <q-separator v-if="reportElement.isFieldFiltered(reportTableColumn.field)" />
        <q-item
          v-close-popup
          :disable="!reportElement.isFieldFiltered(reportTableColumn.field)"
          clickable
          @click.stop="reportElement.resetFieldFilter(reportTableColumn.field); $emit('preview-changes')"
        >
          <q-item-section avatar>
            <q-icon name="clear" />
          </q-item-section>
          <q-item-section>
            Clear {{ reportTableColumn.label }} Filter
          </q-item-section>
        </q-item>
      </template>
      <template v-else>
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('remove-column', reportTableColumn.field)"
        >
          <q-item-section avatar>
            <q-icon name="block" />
          </q-item-section>
          <q-item-section>
            Hide
            <span class="text-bold">
              {{ reportTableColumn.label }}
            </span>
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-if="NUMERIC_COMPONENT_TYPES.includes(reportTableColumn.component)"
          v-close-popup
          clickable
          @click.stop="$emit('toggle-share', reportTableColumn.field)"
        >
          <q-item-section avatar>
            <q-icon :name="reportElement.reportOptions.group_share_columns?.includes(reportTableColumn.field) ? 'check_box' : 'check_box_outline_blank'" />
          </q-item-section>
          <q-item-section>
            {{ reportElement.reportOptions.group_share_columns?.includes(reportTableColumn.field) ? 'Hide' : 'Show' }} share percentage for
            <span class="text-bold">
              {{ reportTableColumn.label }}
            </span>
          </q-item-section>
        </q-item>
        <q-separator v-if="NUMERIC_COMPONENT_TYPES.includes(reportTableColumn.component)" />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('edit-columns')"
        >
          <q-item-section avatar>
            <q-icon name="edit" />
          </q-item-section>
          <q-item-section>
            Edit columns
          </q-item-section>
        </q-item>
      </template>
      <q-separator />
      <q-item
        v-close-popup
        clickable
      >
        <q-item-section>
          <q-checkbox
            v-model="reportElement.reportOptions.subtotals"
            label="Show Subtotals"
            @update:model-value="$emit('preview-changes')"
          />
        </q-item-section>
      </q-item>
      <q-separator />
      <q-item
        v-close-popup
        clickable
      >
        <q-item-section>
          <q-checkbox
            v-model="reportElement.reportOptions.sort_groups"
            label="Sort Groups"
            @update:model-value="$emit('preview-changes')"
          />
        </q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script>
import { NUMERIC_COMPONENT_TYPES } from 'src/models/report/ReportElement'

export default {
  name: 'ReportTableHeaderMenu',
  props: {
    reportElement: {
      type: Object,
      required: true
    },
    reportTableColumn: {
      type: Object,
      required: true
    }
  },
  emits: ['remove-group-by', 'edit-groupings', 'preview-changes', 'remove-column', 'edit-columns', 'toggle-share'],
  data () {
    return {
      NUMERIC_COMPONENT_TYPES
    }
  }
}
</script>
